<template>
  <div class="blip-file-upload-zone">
    <vue-dropzone
      ref="dropzone"
      id="blip-file-upload-zone"
      :options="dropzoneOptions"
      :useCustomSlot="true"
      v-on:vdropzone-files-added="onAddFiles"
      v-on:vdropzone-success="onUploadSuccess"
    >
      <div v-if="!fileUrl" class="dropzone-custom-content">
        <h3 class="dropzone-custom-title"></h3>
        <div class="subtitle">업로드 할 파일을 드롭하거나 클릭하여 업로드 할 파일을 선택하세요!</div>
      </div>
      <div else>
        <img v-bind:src="fileUrl" />
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { BlipFileUploader } from "@/util/BlipFileUploader";
// if(category == 0){
//   categoryName = 'static'
// }else if(category == 1){
//   categoryName = 'profile'
// }else if(category == 2){
//   categoryName = 'collection'
// }else if(category == 3){
//   categoryName = 'topic'
// }else if(category == 4){
//   categoryName = 'artist'
// }else if(category == 5){
//   categoryName = 'dashboard'
// }else if(category == 6){
//   categoryName = 'banner'
// }else if(category == 7){
//   categoryName = 'schedule'
// }else if(category == 8){
//   categoryName = 'imageMan'
// }else if(category == 9){
//   categoryName = 'today'
// }else if(category == 10){
// categoryName = 'notice'
// }else if(category == 11){
// categoryName = 'thread'
// }else if(category == 99){
//   categoryName = 'test'
// }
const MAX_FILE_SIZE = 50;
const MAX_THUMBNAIL_FILE_SIZE = 50;

export default {
  name: "BlipFileUploadZone",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    maxFiles: { type: Number, default: 1 },
    uploadCategory: { type: Number, required: true },
    fileUrl: { type: String, required: false },
    index: { type: Number, required: false, default: -1 },
  },
  async created() {},
  data() {
    return {
      fileIds: [],
      hasSize: true,
      uploadMetaLookup: {},
      dropzoneOptions: {
        addRemoveLinks: false,
        method: "post",
        acceptedFiles: "image/*",
        url: (files) => {
          return files.map((file) => {
            return this.uploadMetaLookup[file.upload.uuid].uploadPath;
          });
        },
        accept: async (file, done) => {
          // file 에 width, height 가 제대로 찍히지 않아 딜레이 줌
          await new Promise((resolve) => setTimeout(resolve, 1000));

          const uploader = new BlipFileUploader();
          console.log(file);

          const result = await uploader.requestUploadUrl({
            category: this.uploadCategory,
            mimeType: file.type,
            fileName: file.name,
            width: file.width,
            height: file.height,
            fileSize: file.size,
          });

          this.uploadMetaLookup[file.upload.uuid] = result;
          this.fileIds.push(result.fileId);
          if (this.index >= 0) {
            this.$emit("onChangeFileIds", [result.fileId], this.index);
          } else {
            this.$emit("onChangeFileIds", [result.fileId]);
          }
          this.$emit("getFileSize", [file.width, file.height]);
          done();
        },
        sending: async (file, xhr, formData) => {
          const postFields = this.uploadMetaLookup[file.upload.uuid].fields;
          for (let [key, value] of Object.entries(postFields)) {
            formData.append(key, value);
          }
        },
        maxFiles: this.maxFiles,
        maxFilesize: MAX_FILE_SIZE,
        maxThumbnailFilesize: MAX_THUMBNAIL_FILE_SIZE,
      },
    };
  },
  methods: {
    async onUploadSuccess(file) {
      const uploader = new BlipFileUploader();
      await uploader.markFileAsUploaded(this.uploadMetaLookup[file.upload.uuid].fileId);
    },
    async onAddFiles() {
      this.uploadMetaLookup = {};
    },
    getFileIds() {
      return this.fileIds;
    },
  },
};
</script>
<style>
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}
.dropzone {
  padding: 0px;
}
.dz-image {
  height: 80% !important;
}
.dz-message {
  margin: 0px !important;
}

.subtitle {
  font-size: 13px;
  color: #314b5f;
}
</style>
